import { API_BASE, request } from './client';

// POST /api/enroll. Defaults to {REACT_APP_API_BASE}/api/enroll; REACT_APP_ENROLL_API_URL overrides it.
// With neither set, submissions are simulated so the form can be tested locally.
const ENROLL_URL = process.env.REACT_APP_ENROLL_API_URL || (API_BASE && `${API_BASE}/api/enroll`);

// Resolves to { ok, id, duplicate, batch } on 200/201 (duplicate = phone already registered — still a success).
// Rejects with ApiError; on 400, error.fieldErrors maps name/phone/email to Bangla messages.
export async function submitEnrollment(payload) {
  if (!ENROLL_URL) {
    // eslint-disable-next-line no-console
    console.info('[enroll] No API configured — simulated submission:', payload);
    await new Promise((resolve) => setTimeout(resolve, 900));
    return { ok: true, simulated: true };
  }

  return request(ENROLL_URL, { method: 'POST', body: JSON.stringify(payload) });
}
